import type { LifeFeatureConfig } from '../../../types/insurances/LifeFeatureConfig';

export const life: LifeFeatureConfig = {
    overview: {
        useCountrySpecificApi: false,
        useBeneficiaryApi: false,
        highlight: {
            showNextPaymentDate: false,
        },
        details: {
            showContractedInsurances: false,
            showVariant: false,
            showPackage: false,
            showContractNumber: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        showCoveredRisks: false,
        showUncoveredRisks: false,
        showInsuredPersons: false,
        showBeneficiaries: false,
    },
    history: {
        visible: false,
    },
    risks: {
        visible: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
